<template>
    <div class="modal-window organization_wrap krs037">
        <header class="modal-header">
            <!-- <div class="tit">{{ modalInfo.title }}</div> -->
            <div class="tit">{{$i18nUtil.trans("message.CoSysOrg.001","부서 선택")}}</div>
            <button @click="modalClose" class="btn_close">X</button>
        </header>
        <div class="modal-content">
            <div class="clear">
                <div class="organization-area admin">
                    <div class="tab_ty2">
                        <div class="tab-content">
                            <div>
                                <div class="tree-area">
                                    <div class="search">
                                        <div class="co">
                                            <!-- <select class="sel_ty3">
                                                <option value="">한화생명</option>
                                            </select> -->
                                        </div>
                                        <!-- <select class="sel_ty3" @change="changeCondition($event.target.value)">
                                            <option value="">부서</option>
                                        </select> -->
                                        <input type="search" v-model="searchKeyword" :placeholder="$i18nUtil.trans('search.placeholder.deptName')"/>
                                        <button class="btn-primary-small black" @click="searchByKeyword">{{$i18nUtil.trans("search.039","검색")}}</button>
                                        <button class="btn-primary-small" v-if="$i18nUtil.getLanguage() === 'ko'" @click="getTreeData">{{$i18nUtil.trans("search.040","초기화")}}</button>
                                    </div>
                                    <div class="treeselect">
                                        <treeselect
                                            v-model="value"
                                            :max-height="250"
                                            :options="treeData"
                                            :default-expand-level="1"
                                            :always-open="alwaysOpen"
                                            :open-on-click="openOnClick"
                                            :load-options="openNode"
                                            :noOptionsText="$i18nUtil.trans('search.041')"
                                            :loadingText="$i18nUtil.trans('search.042')"
                                            :noChildrenText="$i18nUtil.trans('search.043')"
                                            @select="selectNode"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH   } from '@riophae/vue-treeselect';
export default {
    props: {
        modalInfo: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            observer : null,
            value: null,
            alwaysOpen: true,
            multipleYn: true,
            openOnClick: true,
            searchKeyword : null,
            searchCondition : "DEPT"
        }
    },
    beforeDestroy () {
        if(this.observer !== null) {
            this.observer.disconnect();
        }
    },
    mounted() {
        this.getTreeData();
    },
    computed: {
    ...mapState("tree", ["treeData"]),
    },
    methods : {
        /* rest Call&CallBack Action */
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* TreeData 등록 */
        ...mapActions("tree", ["setOrgTree"]),
        /* TreeData 변경&수정 */
        ...mapMutations("tree", ["resetTreeList"]),
        ...mapMutations("tree", ["setTreeOfUserList"]),
        /* 최초 트리 데이터 조회 */
        getTreeData() {
        let area = document.getElementsByClassName("vue-treeselect__control");
        for (let i = 0; i < area.length; i++) {
            area[i].style.display = "none";
        }
        this.resetTreeList(null);
        this.searchKeyword = null;
        let obj = this;
        let reqData = {
            url : "/api/org/getDeptList",
            method : "post",
            params : {
            parentDeptId : null,
            companyId : null
            }
        };
        obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
            if(res.errorCode !== null) {
                let errorCode = res.errorCode;
            } else {
                /* treeData set */
                let rootNode = res.result.rootNode;
                let treeList = res.result.treeList;
    
                obj.setOrgTree({
                rootNode: rootNode,
                treeList: treeList,
                parentNode: null,
                });
            }
            })
            .catch(function (err) {
            console.log(err);
            });
        },
        /* 노드 오픈 */
        async openNode({action, parentNode, callback}) {
            let node = event.target;
            this.observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                node.parentNode.classList.toggle('show');
                node.parentNode.parentNode.parentNode.classList.toggle('show');
                });
            });
            let config = {
                attributes: true, childList: true, characterData: true
            }
            this.observer.observe(node, config);
            let nodeList = [];
            if(action === LOAD_CHILDREN_OPTIONS ) {
                let obj = this;
                let reqData = {
                    url : "/api/org/getDeptList",
                    method : "post",
                    params : {
                        parentDeptId : parentNode.id,
                    }
                };
                await obj.COWORK_REST_SIMPLE_ACTION(reqData)
                .then(function (res) {
                    if(res.errorCode !== null) {
                    } else {
                        let treeList = res.result.treeList;
                        treeList.forEach(function(item, index, arr) {
                            let node = item;
                            let childYn = node.childYn;
                            let nodeInfo = {
                            id: node.deptId,
                            label: node.deptName
                            };
                            if (childYn > 0) {
                                nodeInfo.children = null;
                            }
                            nodeList.push(nodeInfo);
                        });
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
                parentNode.children = nodeList;
            }
        },
        /* 노드 선택 */
        selectNode(node) {
            let obj = this;
            //let NodeId = node.id;       /* 부서아이디 */
            //let NodeName = node.label;  /* 부서이름 */
            EventBus.$emit("returnDept", {
                //modalObj: this,
                deptId: node.id,
                deptName: node.label,                
                deptType: obj.modalInfo.deptType,
            });
            setTimeout(() => {
                obj.$emit('close');
            })
            // let info = {
            //     title: "알림",
            //     contents: this.$i18nUtil.trans("AB042"),
            //     button: "확인"
            // };
            // this.handleDialog(info);
        },
        modalClose() {
            this.$emit('close');
        },
        /* 검색 */
        searchByKeyword() {
            let obj = this;
            if(obj.searchKeyword !== null && obj.searchKeyword !== undefined) {
                /* 부서 & 유저 */
                let reqData = {
                    url : "/api/org/searchByKeyword",
                    method : "post",
                    params : {
                        searchCondition : obj.searchCondition,
                        searchKeyword : obj.searchKeyword
                    }
                };
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(function (data) {
                    if(data.errorCode != null) {
                    let errorCode = data.errorCode;
                    } else {
                    if (obj.searchCondition === "DEPT") {
                        /* treeData set */
                        //let rootNode = data.result.companyInfo;
                        let deptList = data.result;
                        obj.resetTreeList(null);
                        obj.setOrgTree({
                        rootNode: null,
                        treeList: deptList,
                        parentNode: null,
                        searchCondition: obj.searchCondition,
                        });
                    } else {
                        obj.setTreeOfUserList(data.result);
                    }
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
            } else {
                alert("검색어를 입력하세요.")
            }
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/common/organization/org/CoSysOrg.vue